export const RANGE_OPTIONS = [
  {
    label: '+5',
    value: 5
  },
  {
    label: '+10',
    value: 10
  },
  {
    label: '+15',
    value: 15
  }, {
    label: '+20',
    value: 20
  },
  {
    label: '+25',
    value: 25
  },
  {
    label: '+50',
    value: 50
  },
  {
    label: '+75',
    value: 75
  },
  {
    label: '+100',
    value: 100
  },
  {
    label: '+150',
    value: 150
  },
  {
    label: '+200',
    value: 200
  }
]
